import {
  AssignContactTagToolInput,
  CreateContactToolInput,
  CreateTagToolInput,
  GetContactFieldsToolInput,
  GetContactsToolInput,
  GetContactToolInput,
  GetTagsToolInput,
  GetTagToolInput,
  RemoveContactTagToolInput,
  RemoveContactToolInput,
  RemoveTagToolInput,
  UpdateContactToolInput,
  UpdateTagToolInput,
} from './mcp-tool-input'
import { McpToolOutput } from './mcp-tool-output'

export enum McpToolName {
  CreateContact = 'create_contact',
  GetContact = 'get_contact',
  UpdateContact = 'update_contact',
  GetContacts = 'get_contacts',
  RemoveContact = 'remove_contact',
  AssignContactTag = 'assign_contact_tag',
  RemoveContactTag = 'remove_contact_tag',
  GetContactFields = 'get_contact_fields',
  CreateTag = 'create_tag',
  GetTag = 'get_tag',
  GetTags = 'get_tags',
  UpdateTag = 'update_tag',
  RemoveTag = 'remove_tag',
}

export type McpTools = {
  [McpToolName.CreateContact]: {
    input: CreateContactToolInput
    output: McpToolOutput
  }
  [McpToolName.GetContact]: {
    input: GetContactToolInput
    output: McpToolOutput
  }
  [McpToolName.UpdateContact]: {
    input: UpdateContactToolInput
    output: McpToolOutput
  }
  [McpToolName.GetContacts]: {
    input: GetContactsToolInput
    output: McpToolOutput
  }
  [McpToolName.RemoveContact]: {
    input: RemoveContactToolInput
    output: McpToolOutput
  }
  [McpToolName.AssignContactTag]: {
    input: AssignContactTagToolInput
    output: McpToolOutput
  }
  [McpToolName.RemoveContactTag]: {
    input: RemoveContactTagToolInput
    output: McpToolOutput
  }
  [McpToolName.GetContactFields]: {
    input: GetContactFieldsToolInput
    output: McpToolOutput
  }
  [McpToolName.CreateTag]: {
    input: CreateTagToolInput
    output: McpToolOutput
  }
  [McpToolName.GetTag]: {
    input: GetTagToolInput
    output: McpToolOutput
  }
  [McpToolName.GetTags]: {
    input: GetTagsToolInput
    output: McpToolOutput
  }
  [McpToolName.UpdateTag]: {
    input: UpdateTagToolInput
    output: McpToolOutput
  }
  [McpToolName.RemoveTag]: {
    input: RemoveTagToolInput
    output: McpToolOutput
  }
}
